import { BenchmarkingItemWithUnit } from '@/hooks'

export type EntityDetail = {
    id: string
    name: string
    squareFootage: number
}

export const getEntityDetailsMap = (
    data: BenchmarkingItemWithUnit[],
    entityIds: string[]
): Map<string, EntityDetail> => {
    const entityMap = new Map(
        data.map((item) => [item.entityId.toString(), item])
    )
    const resultMap = new Map<string, EntityDetail>()

    for (const entityId of entityIds) {
        const entity = entityMap.get(entityId.toString())
        if (entity) {
            resultMap.set(entityId, {
                id: entityId,
                name: entity.entityName,
                squareFootage:
                    'squareFootage' in entity ? entity.squareFootage : 0,
            })
        } else {
            resultMap.set(entityId, {
                id: entityId,
                name: entityId,
                squareFootage: 0,
            })
        }
    }

    return resultMap
}
